//ハンバーガーメニュー 子メニュー開閉
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".accordion-toggle").forEach(btn => {
    btn.addEventListener("click", () => {
      const submenu = btn.nextElementSibling;
      const isOpen = submenu.classList.contains("open");

      if (isOpen) {
        // 閉じる
        submenu.style.maxHeight = submenu.scrollHeight + "px"; // 現在の高さを固定
        submenu.style.opacity = "1";
        submenu.style.transform = "translateY(0)";

        requestAnimationFrame(() => {
          submenu.style.maxHeight = "0px";
          submenu.style.opacity = "0";
          submenu.style.transform = "translateY(-5px)";
        });

        submenu.classList.remove("open");
        btn.classList.remove("active");
      } else {
        // 開く
        submenu.classList.add("open");
        submenu.style.maxHeight = "0px";
        submenu.style.opacity = "0";
        submenu.style.transform = "translateY(-5px)";

        requestAnimationFrame(() => {
          submenu.style.maxHeight = submenu.scrollHeight + "px";
          submenu.style.opacity = "1";
          submenu.style.transform = "translateY(0)";
        });

        // アニメーション終了後に高さ制限を解除
        submenu.addEventListener("transitionend", function handler(e) {
          if (submenu.classList.contains("open") && e.propertyName === "max-height") {
            submenu.style.maxHeight = "none";
          }
          submenu.removeEventListener("transitionend", handler);
        });

        btn.classList.add("active");
      }
    });
  });
});


//header-search をcart drawerと同じ階層（<header>外に出力させる）
document.addEventListener("DOMContentLoaded", () => {
  const hs = document.querySelector("header-search");
  if (hs) {
    document.body.appendChild(hs); 
  }
});


document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.product-gallery__carousel');

  carousels.forEach(carousel => {
    if (typeof carousel.select === 'function') {
      const originalSelect = carousel.select.bind(carousel);

      carousel.select = function(index) {
        const slide = this.children[index];
        if (!slide) return;

        if (window.innerWidth >= 1000) {
          // PC (1000px以上) → 縦スクロール
          this.scrollTo({
            top: slide.offsetTop,
            behavior: 'smooth'
          });
        } else {
          // モバイル/タブレット → 既存処理
          originalSelect(index);
        }

        this.dispatchEvent(new CustomEvent('carousel:change', {
          detail: { index }
        }));
      };

      // ★ スクロール監視で現在スライドを判定
      let ticking = false;
      carousel.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const slides = Array.from(carousel.children);
            const scrollPos = carousel.scrollTop;
            const index = slides.findIndex(slide => 
              slide.offsetTop <= scrollPos + carousel.clientHeight / 2 &&
              slide.offsetTop + slide.clientHeight > scrollPos + carousel.clientHeight / 2
            );
            if (index >= 0) {
              carousel.dispatchEvent(new CustomEvent('carousel:change', {
                detail: { index }
              }));
            }
            ticking = false;
          });
          ticking = true;
        }
      });
    }
  });
});


